import React, {PropTypes, Component} from 'react'
import {connect} from 'react-redux'
import { MenuItem, Dropdown } from 'react-bootstrap'
import { Table } from 'components/UI'
import { PAYMENT_METHOD } from 'data/constants'
import {fetchTradeRecord as fetchTradeRecordActionCreator} from './ducks'
import tableSettingsFactory from "./table-settings";
import FilterBy from 'template/FilterBy'
import ExportModal from 'template/Modals/Export';
import OnBoardingNatural from 'template/OnBoardingNatural';
import { onBoardingContents } from './constant';
import StudentName from 'components/StudentName';
import './FinanceTable.scss'
import __R, { userCan } from 'containers/__R'
import locale from './locale'

const CONTROLLER_WIDTH = '10%'

const mapStateToProps = (state) => ({
  user: state.user,
  gSubscription: state.gSubscription,
  financeTable: state.financeTable
})

class FinanceTable extends Component {

	static propTypes = {
		type: PropTypes.string.isRequired, // either student_record or all_record
  }

  constructor(props){
    super(props)

    this.state = {
      filterData: {
      },
      fetchTradeRecordParams: {
        student_id_list: props.type == 'student_record' ? props.studentIds : null,
      },
    }

    if (props.type == 'student_record') {
      if (!Array.isArray(props.studentIds)) {
        throw new Error(`When type is 'student_record', eg: studentIds={[1,2,3]} is required.`);
      }
      this.state.defaultFilterTypes = ['class', 'daterange', 'text:transaction_number'];
    } else if (props.type == 'all_record') {
      this.state.defaultFilterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
    }

    this.state.filterTypes = this.state.defaultFilterTypes;

    this.fetchTradeRecord = this.fetchTradeRecord.bind(this);;
    this.onFilterChange = this.onFilterChange.bind(this)
    this.onPageChange = this.onPageChange.bind(this);
    this.onItemsCountPerPageChange = this.onItemsCountPerPageChange.bind(this);
    this.filterOptions = {
      class: {
        selectMultiple: true,
        disabled: !userCan('class_channel') || !userCan('private_class_channel')
      },
      student: {
        selectMultiple: true,
        onlyFetchCurrent: false,
        disabled: !userCan('student_channel')
      },
      'text:transaction_number': {
        placeholder: __('E-Receipt Number', 'finance'),
      },
    }
  }

  componentWillMount(){
    this.fetchTradeRecord();
  }

  exportTradeRecord(format) {
    const { fetchTradeRecordParams } = this.state;
    
    ExportModal({
      type: 'finance',
      title: 'Export Transaction Records',
      format: format,
      params: fetchTradeRecordParams
    })
  }

  fetchTradeRecord(paginationIn) {
    let { pagination } = this.props.financeTable;
    let { dispatch, studentId } = this.props;
    let { fetchTradeRecordParams } = this.state;

    const paginationParams = { ...pagination, ...paginationIn}
    const schoolId = localStorage.getItem('schoolId')

    dispatch(fetchTradeRecordActionCreator(schoolId, fetchTradeRecordParams, paginationParams))
  }

  onPageChange(activePage) {
    if (activePage == this.props.financeTable.activePage) {
      return;
    }

    this.fetchTradeRecord({
      activePage,
    });
  }

  onItemsCountPerPageChange(itemsCountPerPage) {
    this.fetchTradeRecord({
      itemsCountPerPage,
    });
  }

  onFilterChange({ filterData, lastFilterChanged }){
    this.setState({
      filterData,
      lastFilterChanged,
    }, ()=>{
      this.filterList()
    })
  }

  filterList(){
    const schoolId = localStorage.getItem('schoolId')
    const {student = {}, daterange, transaction_number} = this.state.filterData;
    const cls = this.state.filterData.class || {};
    const { lastFilterChanged } = this.state;
    const { type } = this.props;

    let filterTypes = Array.from(this.state.filterTypes);

    if (type == 'all_record') {
      if(lastFilterChanged == 'student') {
        filterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
      }

      if(lastFilterChanged == 'class'){
        filterTypes = ['student', 'class', 'daterange', 'text:transaction_number'];
      }

      if(!student.IDs && !cls.IDs) {
        filterTypes = this.state.defaultFilterTypes;
      }
    }

    let startEndDate = {}

    if (daterange && daterange.startDate && daterange.endDate) {
      startEndDate = {
        start_date: daterange.startDate.format('YYYY-MM-DD'),
        end_date: daterange.endDate.format('YYYY-MM-DD'),
      }
    }

    this.setState({
      filterTypes,
      fetchTradeRecordParams: {
        student_id_list: type == 'student_record' ? this.props.studentIds : student.IDs,
        class_id_list: cls.IDs,
        transaction_number,
        ...startEndDate,
      }
    }, ()=>{
      this.fetchTradeRecord(this.state.fetchTradeRecordParams);
    });

  }
  checkStudentUpdate(isUpdated) {
    if(isUpdated) {
      this.fetchTradeRecord();
    }
  }
  render(){
    let {dispatch, type} = this.props

    const fields = [{
      name: 'transaction_date',
      title: __('Date', 'class'),
    }, {
      name: 'transaction_number',
      title: __('E-Receipt No.', 'finance')
    },{
      name: 'student_name',
      title: __('Student', 'finance'),
      getTdContent: ({ trData: financeInfo })=>{
        const {
          trStudent,
          student_name,
        } = financeInfo;
        return <StudentName id={trStudent} name={student_name} checkStudentUpdate={(isUpdated)=>this.checkStudentUpdate(isUpdated)}/>
      },
    }, {
      name: 'class_name',
      title: __('Class', 'student'),
      getTdContent: ({ trData: financeInfo })=>{
        return financeInfo.class_name ? financeInfo.class_name : __('School Credit', 'PaymentModal');
      },
    }, {
      name: 'trType',
      title: __('Charge/Refund', 'finance'),
      getTdContent: ({ trData: financeInfo })=>{
        return financeInfo.trType == 1 ? __('Charge', 'finance') : __('Refund', 'finance');
      },
    }, {
      name: 'trTransactionAmount',
      title: __('Amount', 'finance'),
      getTdContent: ({trData: financeInfo})=>{
        return financeInfo.trTransactionAmount.replace(/\.00/, '') + 'CAD'
      }
    }, {
      name: 'discount_amount',
      title: __('Discount Price', locale),
      getTdContent: ({trData: financeInfo})=>{
        return financeInfo.discount_amount.replace(/\.00/, '') + 'CAD'
      }
    },{
      name: 'source_or_direction',
      title: __('Payment Methods', 'finance'),
      getTdContent: ({ trData: financeInfo })=>{
        return PAYMENT_METHOD[financeInfo.source_or_direction]
      },
    }, {
      name: 'trQuantity',
      title: __('Purchased Lessons', 'finance'),
      getTdContent: ({ trData: financeInfo })=>{
        if(financeInfo.class_name.length == 0){
          return 'N/A';
        }
        else if(financeInfo.trEndDate){
          return __('To', 'finance') + ' ' + financeInfo.trEndDate;
        }else {
          return Math.round(financeInfo.trQuantity) + __('', 'classdetail')
        }
      },
    }, {
      name: 'operator_name',
      title: __('Operator', 'finance')
    }]

		const content = onBoardingContents;

    const schoolId = localStorage.getItem('schoolId')
    const {list = [], fetching = false, pagination, hasPermission, school_has_traderecord} = this.props.financeTable
    this.tableSettings = tableSettingsFactory.call(this);

    if((school_has_traderecord == false && content) || hasPermission == false ){
      return(
        <OnBoardingNatural
          isShown={true}
          title={content.title}
          text={content.text}
          image={content.image}
          showArrow={content.showArrow}
        />
      )
    }

    return(
      <div className='finance-table'>
        <div className='util-section'>
          <FilterBy
            filterData={this.state.filterData}
            selectMultiple={true}
            filters={this.state.filterTypes}
            options={this.filterOptions}
            schoolId={schoolId}
            onChange={this.onFilterChange}
          />
          {/* <__R can="export_trade_record" by='disable'>
            <button className='btn btn-primary pull-right' onClick={() => {this.exportTradeRecord('csv')}} disabled={list.length===0}>
              {__('Export Record to CSV', 'teacherAttendance')}
            </button>
          </__R>
          <__R can="export_trade_record" by='disable'>
            <button className='btn btn-primary pull-right' onClick={() => {this.exportTradeRecord('excel')}} disabled={list.length===0}>
              {__('Export Record to Excel', 'teacherAttendance')}
            </button>
          </__R> */}
          <Dropdown>
            <Dropdown.Toggle className='btn-defult expand-to-right expand-to-down'>
              {__('Export Record', locale)}
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <MenuItem
                eventKey="export-record"
                onSelect={()=>{this.exportTradeRecord('excel')}}
                disabled={!userCan('export_trade_record') || list.length===0}
              >
                {__('To Excel', locale)}
              </MenuItem>
              <MenuItem 
                eventKey="export-record" 
                onSelect={()=>{this.exportTradeRecord('csv')}} 
                disabled={!userCan('export_trade_record') || list.length===0}>
                {__('To CSV', locale)}
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </div>
        <Table
          data={list}
          fields={fields}
          className='teacher-table'
          settingThTitle={__('Settings', 'class')}
          settingWidth={CONTROLLER_WIDTH}
          settings={this.tableSettings}
          useMultiSelection={false}
          oneSettingPerRow={false}
          fetching={fetching}

          dropdownGuideWidth={160}
          dropdownGuideHeight={228}

          pagination={pagination}
          usePagination={true}
          onPageChange={this.onPageChange}
          onItemsCountPerPageChange={this.onItemsCountPerPageChange}
        />
      </div>
    )
  }
}


export default connect(mapStateToProps)(FinanceTable)



// WEBPACK FOOTER //
// ./src/containers/tables/FinanceTable/index.js